var map = {
	"./BaseComment/index.vue": "./src/components/BaseComment/index.vue",
	"./BaseForm/index.vue": "./src/components/BaseForm/index.vue",
	"./BaseTable/index.vue": "./src/components/BaseTable/index.vue",
	"./CascaderArea/index.vue": "./src/components/CascaderArea/index.vue",
	"./CurrentPageModule/index.vue": "./src/components/CurrentPageModule/index.vue",
	"./Developing.vue": "./src/components/Developing.vue",
	"./DialogComment/index.vue": "./src/components/DialogComment/index.vue",
	"./RichTextView/index.vue": "./src/components/RichTextView/index.vue",
	"./SelectServer/index.vue": "./src/components/SelectServer/index.vue",
	"./VideoPlayer/index.vue": "./src/components/VideoPlayer/index.vue",
	"./baseImage/index.vue": "./src/components/baseImage/index.vue",
	"./board.vue": "./src/components/board.vue",
	"./deviceSelector.vue": "./src/components/deviceSelector.vue",
	"./mediaSelector.vue": "./src/components/mediaSelector.vue",
	"./statistics/deviceStatus.vue": "./src/components/statistics/deviceStatus.vue",
	"./uploadAudio.vue": "./src/components/uploadAudio.vue",
	"./uploadImage.vue": "./src/components/uploadImage.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components sync recursive \\.vue$";